import React from 'react';

import SmartLink from 'Shared/components/SmartLink';

import jiraLogo from 'Shared/images/JiraLogo.png';
import JiraIssueSmartMenu from '../SmartMenu/JiraIssueSmartMenu';
import { SmartLinkLogo, SmartLinkContainer } from '../components';
import { useFlags } from 'launchdarkly-react-client-sdk';

type Props = {
  children: React.ReactNode;
};

const JiraIssueLink = ({ children, ...restProps }: Props) => {
  const { jiraIntegration } = useFlags();

  const SmartLinkJsx = ({ children }) => {
    return (
      <SmartLink {...restProps} hasBadge>
        <SmartLinkLogo src={jiraLogo} />
        {children}
      </SmartLink>
    );
  };

  return (
    <SmartLinkContainer contentEditable={false}>
      {jiraIntegration ? (
        <JiraIssueSmartMenu {...restProps}>
          <SmartLinkJsx>{children}</SmartLinkJsx>
        </JiraIssueSmartMenu>
      ) : (
        <SmartLinkJsx>{children}</SmartLinkJsx>
      )}
    </SmartLinkContainer>
  );
};

export default JiraIssueLink;
